import { withNamespaces } from "react-i18next";
import {
    Button,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
} from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";

const DeletionTaskModal = function ({
    isOpen,
    close,
    t,
    taskId,
    acceptDeletion
}) {
    return (
        <Modal
            size="lg"
            scrollable={true}
            isOpen={isOpen}
            backdrop="static"
        >
            <ModalHeader toggle={close}>
                {t("Delete Task")}
            </ModalHeader>

            <ModalBody>
                <AvForm className="needs-validation">
                    <Row>
                        <Label>{t("Are you sure?")}</Label>
                    </Row>

                    <ModalFooter>
                        <Button
                            color="danger"
                            className="waves-effect waves-light"
                            type="submit"
                            onClick={() => {
                                acceptDeletion(taskId);
                            }}
                        >
                            {t("Delete")}
                        </Button>
                        <Button
                            color="secondary"
                            className="waves-effect waves-light"
                            type="button"
                            onClick={close}
                        >
                            {t("Cancel")}
                        </Button>
                    </ModalFooter>
                </AvForm>
            </ModalBody>
        </Modal>
    );
};

export default withNamespaces()(
    DeletionTaskModal
);
